module.exports = __webpack_public_path__ + "static/media/history-icon.91cddb0d.svg";